import { node, string } from "prop-types";

import cx from "classnames";

const propTypes = {
  children: node,
  className: string,
  backgroundColor: string,
};

const ContainerBleed = (props) => {
  const { children, className, backgroundColor, ...otherProps } = props;
  return (
    <div
      {...otherProps}
      style={{ ["--background-color"]: backgroundColor }}
      //js-container for the chevron animation
      className={cx("container", "container--bleed", className, "js-container")}
    >
      {children}
    </div>
  );
};

ContainerBleed.propTypes = propTypes;
export default ContainerBleed;
